'use client';
/*
 * @providesModule DeepLinkUtils
 *
 */
import getGameId from '@/utils/getGameId';
import {getEnvConfig} from '@/utils/getEnvConfig';
import {SkillzRouter} from '@sdk-mobile';
import Cookies from 'js-cookie';

const gameId = getGameId();
const userId = Cookies.get(getEnvConfig().CURRENT_USER_COOKIE_NAME);
const baseUrl = `/games/${gameId}`;

type DeepLinkType =
  | 'matchSelect'
  | 'showChat'
  | 'showHome'
  | 'showInviteFriend'
  | 'showLeaderboards'
  | 'showStore'
  | 'showTrophies'
  | 'showTicketz';

interface DeepLinkConfig {
  url: string;
  paramsHandler?: (params: Record<string, string>) => string;
}

const deepLinkToUrlConfigs: Record<DeepLinkType, DeepLinkConfig> = {
  matchSelect: {
    url: '/home',
    // TODO: Future reference - An example of handling deep link with params,
    // when we port remaining logic of DeepLinkUtils to web
    paramsHandler: (params) => {
      // Placeholder return, process deepLink params here and modify return value as necessary
      void params;
      return '/home';
    },
  },
  showChat: {url: ''},
  showHome: {url: '/history'},
  showInviteFriend: {url: '/referral-friend'},
  showLeaderboards: {url: '/leagues'},
  showStore: {url: '/store'},
  showTrophies: {url: `/users/${userId}/trophies`},
  showTicketz: {url: '/ticketz'},
};

const convertDeepLinkToUrl = (type: DeepLinkType, params: Record<string, string>): string => {
  const urlConfig = deepLinkToUrlConfigs[type];
  if (!urlConfig) return '';

  if (urlConfig.paramsHandler && params && Object.keys(params).length > 0) {
    return `${baseUrl}${urlConfig.paramsHandler(params)}`;
  }

  return `${baseUrl}${urlConfig.url}`;
};

const navigateToUrl = (type: DeepLinkType, params: Record<string, string>): void => {
  const url = convertDeepLinkToUrl(type, params);
  if (url) SkillzRouter.replace(url);
};

const parseDeepLink = (
  deepLink: string
): {type: DeepLinkType; params: Record<string, string>} | null => {
  if (!deepLink.startsWith('skillz://')) return null;

  const [type, queryString] = deepLink.substring(9).split('?');
  const params = queryString ? Object.fromEntries(new URLSearchParams(queryString)) : {};

  return {type: type as DeepLinkType, params};
};

export default class DeepLinkUtils {
  static executePendingURLLinking(didExecuteCompletion?: (didLink: boolean) => void): void {
    console.log('Reached web mock of DeepLinkUtils.executePendingURLLinking');
    didExecuteCompletion?.(false);
  }

  static handleDeeplink(deepLink: string, completion?: () => void): void {
    if (deepLink?.startsWith?.('http')) {
      window.open(deepLink, '_system');
      return completion?.();
    }

    const parsedDeepLink = parseDeepLink(deepLink);
    if (parsedDeepLink) {
      navigateToUrl(parsedDeepLink.type, parsedDeepLink.params);
    }

    completion?.();
  }
}
